import { ErrorHandler, inject, InjectionToken } from '@angular/core';
import { catchError, Observable, OperatorFunction, pipe } from 'rxjs';
import { PSError, PSErrorOptions } from './ps-error';
import { HttpErrorResponse } from '@angular/common/http';

type Options = Partial<PSErrorOptions> & { notify?: boolean };
type PSCatchErrorFn = <T, R>(
  handler: (error: PSError) => Observable<R>,
  options?: Options,
) => OperatorFunction<T, T | R>;

export const PS_CATCH_ERROR = new InjectionToken<PSCatchErrorFn>(
  'PS_CATCH_ERROR',
  {
    providedIn: 'root',
    factory: () => {
      const errorHandler = inject(ErrorHandler);

      return (handler, options = {}) =>
        pipe(
          catchError((error) => {
            const psError =
              error instanceof HttpErrorResponse && !options.customMessage
                ? PSError.http(error, options)
                : PSError.from(
                    options.customMessage ?? error.message,
                    options.context,
                    { notify: !!options?.notify, ...options.metadata },
                  );

            errorHandler.handleError(psError);
            return handler(psError);
          }),
        );
    },
  },
);
